import React from 'react';
import PropTypes from 'prop-types';

import { getCheckerQuestion, VALIDATION_STATUSES } from '../../../../lib/checker';
import { INCOMPLETE } from '../../../../lib/exercise';

import { Show } from '../../../show';

import GridContainer from '../../../layouts/components/grid-container';
import OverflowContainer from '../../../layouts/components/overflow-container';
import FluidContainer from '../../../layouts/components/fluid-container';

import { Body } from '../../../typography';
import Spacer from '../../../spacer';
import Button from '../../../button';
import CheckerStep from '../checker-step';

const Execution = ({ exercise, correctionStatus, steps, correctable, onChange, onDelete, onOpen, onAdd, openedStep }) => {
    return (
        <>
            <Body weight="semi-bold">{'Svolgimento'}</Body>
            {steps.map((step, index) => {
                return (
                    <React.Fragment key={`${index}${steps.length}`}>
                        <Spacer size="small" />
                        <OverflowContainer>
                            <GridContainer
                                paddingY={['xxs', 'small']}
                                paddingX="small"
                                gridGap="small"
                                templateColumns="auto minmax(0, 1fr) auto"
                            >
                                <CheckerStep
                                    index={index + 1}
                                    content={step.value}
                                    isOpened={index === openedStep}
                                    onChange={(value) => onChange(index, value)}
                                    onConfirm={() => {
                                        onAdd(index);
                                    }}
                                    onDelete={() => {
                                        if (steps.length > 1) {
                                            onDelete(index);
                                        } else {
                                            onChange(index, getCheckerQuestion(exercise.question));
                                        }
                                    }}
                                    onOpen={() => onOpen(index)}
                                    validation={correctable && step.validationStatus}
                                    isCorrection={!!correctionStatus}
                                />
                            </GridContainer>
                        </OverflowContainer>

                        <Show when={index === openedStep && !correctionStatus}>
                            <Spacer size="small" />
                            <OverflowContainer>
                                <FluidContainer paddingY={['xxs', 'small']} paddingX="regular">
                                    <Button
                                        type="tertiary"
                                        size="small"
                                        onClick={() => {
                                            onAdd(index);
                                        }}
                                    >
                                        {'Aggiungi passaggio'}
                                    </Button>
                                </FluidContainer>
                            </OverflowContainer>
                        </Show>
                    </React.Fragment>
                );
            })}
            <Spacer size="small" />
            <Show when={correctionStatus && correctionStatus.state === INCOMPLETE}>
                <OverflowContainer>
                    <GridContainer
                        paddingY={['xxs', 'small']}
                        paddingX="small"
                        borderRadius={[0, 'normal']}
                        gridGap="small"
                        templateColumns="auto minmax(0, 1fr) auto"
                        border="1px solid black"
                    >
                        <CheckerStep
                            index={steps.length + 1}
                            content={`Mancante: &nbsp; ${exercise.answerContent}`}
                            isCorrection={true}
                            validation={VALIDATION_STATUSES.MISSING}
                        />
                    </GridContainer>
                </OverflowContainer>
            </Show>
        </>
    );
};

Execution.propTypes = {
    exercise: PropTypes.object,
    correctionStatus: PropTypes.object,
    steps: PropTypes.array,
    correctable: PropTypes.bool,
    containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    onOpen: PropTypes.func,
    onAdd: PropTypes.func,
    openedStep: PropTypes.any,
};

export default Execution;
